import React, { useState, useEffect } from "react";

export const LocalStorageManager = ({ type, key, params }) => {
  const [alreadyDone, setAlreadyDone] = useState(false);

  useEffect(() => {
    if (!alreadyDone) {
      let _params;

      if (typeof params === 'string') {
        _params = params;
      } else {
        _params = JSON.stringify(params);
      }

      switch (type) {
        case 'set':
          localStorage.setItem(key, _params);
          break;
        case 'get':
          localStorage.getItem(key, _params);
          break;
        case 'delete':
          localStorage.removeItem(key, _params);
          break;
      }

      setAlreadyDone(true);
    }
  }, []);

  return <></>;
};

export default LocalStorageManager;